import React, { useEffect, useState } from "react"
import { ConfigProvider, Modal, theme } from "antd"
import { extendBannerBot, getExtendCalculation } from "../../services/bannerBotApis"
import { toast } from "react-toastify"

const ExtendModal = ({ botId }) => {
    const [calculation, setCalculation] = useState({})
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => setIsOpen(!isOpen)

    useEffect(() => {
        if (isOpen) {
            getExtendCalculation(botId).then(({ data }) => {
                setCalculation(data)
            })
        }
    }, [isOpen])

    return (
        <>
            <button
                onClick={toggleModal}
                style={{ backgroundColor: "#22C55E" }}
                className="flex justify-center gap-2 border bg-green-500 text-white rounded-3xl px-4 py-2 m-2 transition duration-500 ease select-none hover:bg-green-600 focus:outline-none focus:shadow-outline"
            >
                <img src="assets/icons/repeat.svg" className="pt-1" width="20px" height="20px" />
                <p>تمدید</p>
            </button>
            <ConfigProvider direction="rtl" theme={{ algorithm: theme.darkAlgorithm }}>
                <Modal
                    title="تمدید بات بنر داینامیک با بنر ها"
                    open={isOpen}
                    onCancel={toggleModal}
                    onOk={() => {
                        toggleModal()
                        toast.promise(extendBannerBot(botId), {
                            pending: "درحال تمدید",
                            success: "تمدید شد",
                        })
                        // submitHandler.delBanner(banner.id)
                    }}
                    okText={"تمدید"}
                    cancelText={"بیخیال!"}
                    okType="warning"
                    okButtonProps={{ type: "primary" }}
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <div className="flex justify-between mx-2">
                                <div>مجموع: {calculation?.botPrice?.toLocaleString("en-US")} تومان</div>
                                <div className="flex gap-2">
                                    <CancelBtn />
                                    <OkBtn />
                                </div>
                            </div>
                        </>
                    )}
                >
                    <>
                        <div className="bg-stone-800 mt-5 p-2 border-sky-500 border-2 rounded-md max-h-96 overflow-y-auto">
                            <div>
                                {calculation &&
                                    calculation.calculationDescription?.map(({ type, line }, index) =>
                                        type == "info" ? (
                                            <div key={index} className="flex justify-center text-blue-500">
                                                {line}
                                            </div>
                                        ) : (
                                            <div key={index} className="text-green-500">
                                                {line}
                                            </div>
                                        ),
                                    )}
                            </div>
                        </div>
                    </>
                </Modal>
            </ConfigProvider>
        </>
    )
}

export default ExtendModal
